import React, { memo, useEffect, useState } from 'react'
import { Position } from 'reactflow'
import SvgIcon from './common/SvgIcon'
import { SourceHandle, TargetHandle } from './handle'
import styles from './index.less'
import type { CustomNodeData } from '../nodes/types'

interface CustomNodeWrapperProps {
  children?: React.ReactNode
  nodeData: CustomNodeData
  selected?: boolean
}

// TODO：node为input 或 output 时会被react-flow按默认类型添加边框 修改typeName
// ps: https://reactflow.dev/api-reference/types/node#default-node-types
function CustomNodeWrapper({
  children,
  nodeData,
  selected,
}: CustomNodeWrapperProps) {
  // const id = useNodeId();
  const [nodeType, setNodeType] = useState<
    'input' | 'output' | 'JavaPluginAction' | 'LLMAction' | 'MessageAction'
  >(nodeData.nodeType)
  const [showErr, setShowErr] = useState<boolean>(false)
  const [showHandle, setShowHandle] = useState<boolean>(false)

  const generateHandles = () => {
    // if (!showHandle) return null;
    if (nodeType === 'input') {
      return (
        <React.Fragment>
          {/* <SourceHandle id={'top'} position={Position.Top} /> */}
          <SourceHandle
            id="bottom"
            showHandle={showHandle}
            position={Position.Bottom}
          />
          {/* <SourceHandle id={'left'} position={Position.Left} />
          <SourceHandle id={'right'} position={Position.Right} /> */}
        </React.Fragment>
      )
    }
    if (nodeType === 'output') {
      return (
        <React.Fragment>
          <TargetHandle
            id="top"
            showHandle={showHandle}
            position={Position.Top}
          />
          {/* <TargetHandle id="bottom" position={Position.Bottom} />
          <TargetHandle id="left" position={Position.Left} />
          <TargetHandle id="right" position={Position.Right} /> */}
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <TargetHandle
          id="top"
          showHandle={showHandle}
          position={Position.Top}
        />
        <SourceHandle
          id="bottom"
          showHandle={showHandle}
          position={Position.Bottom}
        />
        <SourceHandle
          id="left"
          showHandle={showHandle}
          position={Position.Left}
        />
        <SourceHandle
          id="right"
          showHandle={showHandle}
          position={Position.Right}
        />
      </React.Fragment>
    )
  }

  useEffect(() => {
    if (!nodeData.hasErr) {
      setShowErr(false)
    }
    setNodeType(nodeData.nodeType)
  }, [nodeData])
  return (
    <div
      className={`${styles.wrapper}`}
      style={{
        ...nodeData?.nodeStyle,
        height: nodeData?.height,
        width: nodeData?.width,
        border: selected
          ? '2px solid #5582f3'
          : nodeData.hasErr
            ? '2px solid red'
            : undefined,
      }}
      onMouseEnter={() => setShowHandle(true)}
      onMouseLeave={() => setShowHandle(false)}
    >
      {/* id:{id} */}
      <div className={styles.content}>
        <SvgIcon type={nodeData.nodeType} />
        <span className={styles.name} title={nodeData.nodeName}>
          {children}
        </span>
      </div>
      {generateHandles()}
      {
        nodeData.hasErr
          ? (
              <span
                className={`${styles.error}`}
                onMouseEnter={() => setShowErr(true)}
                onMouseLeave={() => setShowErr(false)}
                // title={nodeData.errInfo.reduce(
                //   (a, item) => a + item.msg,
                //   '',
                // )}
              >
                !
                <div
                  style={{
                    display: showErr ? 'block' : 'none',
                    boxShadow: `0px 4px 10px 0px rgba(0,0,0,0.2)`,
                  }}
                  className={`${styles.errorText}`}
                >
                  {nodeData.errInfo.reduce((a, item) => a + item.msg, '')}
                </div>
              </span>
            )
          : null
      }
    </div>
  )
}

export default memo(CustomNodeWrapper)
